export function normalize(value) {
    return (value ?? '').toString().trim().toLowerCase();
}

export function isHtmlInputElement(value) {
    return typeof HTMLInputElement !== 'undefined' && value instanceof HTMLInputElement;
}

export function parseDatasetClassnames(el) {
    if (!el?.dataset?.classnames) return [];
    return el.dataset.classnames
        .toString()
        .split(/\s+/)
        .map((c) => c.trim())
        .filter(Boolean);
}

/**
 * Get CSRF token (sync). Returns the cached token from refreshCsrfToken,
 * or null if not yet fetched.
 * @returns {{name: string, value: string}|null}
 */
export function getCsrfToken() {
    // Import is at module level to avoid circular deps; use dynamic import pattern
    // The token is populated by refreshCsrfToken.init() which runs on DOMContentLoaded
    return window.__csrfToken || null;
}
